import React from "react";

import HomeExpertCategories from "./HomeExpertCategories";
import HomePageBanner from "./HomePageBanner";
import Faqs from "../../../components/Home/Faqs";

const UserHomePage = () => {
  return (
    <div className="mb-28">
      <HomePageBanner />
      <HomeExpertCategories />
      <div className="mt-28 lg:mt-60">
        <Faqs />
      </div>
    </div>
  );
};

export default UserHomePage;
